import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Home } from 'lucide-react';

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-[#fafcff] flex items-center justify-center relative overflow-hidden px-4">
      {/* BACKGROUND TEXTURE */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `repeating-linear-gradient(-45deg, rgba(15, 105, 157, 0.02) 0px, rgba(15, 105, 157, 0.02) 1px, transparent 1px, transparent 18px)`,
        }}
      />
      
      {/* Decorative Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#006699]/5 rounded-full blur-[100px] pointer-events-none" />

      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, type: 'spring', bounce: 0.4 }}
        className="bg-white border-2 border-[#006699]/10 p-8 sm:p-12 max-w-lg w-full text-center shadow-[0_20px_50px_rgba(0,102,153,0.1)] relative"
      >
        {/* L Corners */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t-4 border-l-4 border-[#006699] pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b-4 border-r-4 border-[#006699] pointer-events-none" />

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.3, type: 'spring', stiffness: 200 }}
          className="w-24 h-24 bg-[#006699]/10 rounded-full flex items-center justify-center mx-auto mb-8"
        >
          <CheckCircle className="w-12 h-12 text-[#006699]" />
        </motion.div>

        <h1 className="text-3xl sm:text-4xl font-black text-[#00334d] uppercase tracking-tighter mb-4">
          Registration Complete
        </h1>
        
        <p className="text-slate-500 mb-8 leading-relaxed">
          Thank you for applying to join IEEE ISIMS Student Branch. We have received your information and our team will get in touch with you shortly.
        </p>

        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#006699]/20 to-transparent mb-8" />

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto bg-[#006699] hover:bg-[#00334d] text-white font-bold text-xs uppercase tracking-widest px-6 py-4 flex items-center justify-center gap-2 transition-colors rounded-none"
          >
            <Home className="w-4 h-4" />
            Back to Home
          </Link>
          <Link
            to="/events"
            className="w-full sm:w-auto bg-transparent border-2 border-[#006699]/20 hover:border-[#006699] text-[#006699] font-bold text-xs uppercase tracking-widest px-6 py-4 flex items-center justify-center gap-2 transition-colors rounded-none"
          >
            Explore Events
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
